import type { DisconnectSlackMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  DisconnectSlackDocument,
  GetNotificationPreferencesDocument,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDisconnectSlack = createMutationHook({
  name: 'disconnectSlack',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.notifications.slack.disconnect.mutationOptions({ onSuccess }),
  mapInput: (_input: void) => undefined,
  invalidate: (trpc) => [
    trpc.frontend.notifications.slack.getConnection.queryKey(),
  ],
  mapResponse: (result: { message: string }): DisconnectSlackMutation => ({
    disconnectSlack: {
      __typename: 'DisconnectSlackOutput',
      message: result.message,
    },
  }),
  graphqlDocument: DisconnectSlackDocument,
  graphqlVariables: () => ({}),
  refetchQueries: [GetNotificationPreferencesDocument],
});
